import { Building2, Users, Clock, CheckCircle } from 'lucide-react';

// Stats Card Component
const StatCard = ({ label, value, icon: Icon, color }) => (
  <div className="glass-card rounded-xl p-6">
    <div className="flex items-center justify-between mb-4">
      <span className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-500">{label}</span>
      <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${color}`}>
        <Icon className="w-5 h-5" />
      </div>
    </div>
    <p className="text-3xl font-bold text-white">{value}</p>
  </div>
);

// Admin Dashboard Overview
export const AdminOverview = ({ stats }) => (
  <div className="space-y-8">
    <div>
      <p className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-500 mb-2">Overview</p>
      <h1 className="text-3xl font-bold text-white tracking-tight">Admin Dashboard</h1>
    </div>

    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <StatCard 
        label="Total Users" 
        value={stats.total_users} 
        icon={Users} 
        color="bg-blue-500/20 text-blue-400" 
      />
      <StatCard 
        label="Total Businesses" 
        value={stats.total_businesses} 
        icon={Building2} 
        color="bg-purple-500/20 text-purple-400" 
      />
      <StatCard 
        label="Pending Review" 
        value={stats.pending_businesses} 
        icon={Clock} 
        color="bg-yellow-500/20 text-yellow-400" 
      />
      <StatCard 
        label="Verified" 
        value={stats.verified_businesses} 
        icon={CheckCircle} 
        color="bg-green-500/20 text-green-400" 
      />
    </div>
  </div>
);

export default AdminOverview;
